export default {
  closeAll: "Cerrar todo",
  comment: "Comentario",
  edit: "Editar",
  expandAll: "Expandir todo",
  howDoYouRateThisService: "¿Cómo evalúa este servicio",
  imDissatisfied: "Estoy insatisfecho",
  imSatisfied: "Estoy satisfecho",
  knowWhatYouThink: "Queremos saber lo que piensa",
  loading: "Cargando..",
  next: "Próxima",
  no: "No",
  neutral: "Neutro",
  openedIn: "Abierto en",
  owner: "Responsable",
  pageNotFound: "Página no encontrada",
  ratingOf: "Comentario de {{name}}",
  requester: "Solicitante",
  satisfied: "Bueno",
  saveComment: "Guardar comentario",
  send: "Enviar",
  service: "Servicio",
  thanks: "Muchas gracias",
  ticketSummary: "Resumen del ticket",
  unsatisfied: "Malo",
  verySatisfied: "Perfecto",
  veryUnsatisfied: "Pésimo",
  withYourFeedbackWeCanImproveRelationship:
    "Con su feedback siempre podemos mejorar nuestro relacionamiento",
  yes: "Sí",
  yourOpinionWorthALot: "Su opinión vale mucho para nosotros",
  yourRatingHasAlreadyBeenSaved:
    "Su evaluación para nuestra atención ya ha sido salvada."
};
